import { jsx as r, jsxs as s } from "react/jsx-runtime";
import m from "classnames";
import c from "../../utils/colors.js";
import { f as h } from "../../styled-qu50FBLM.mjs";
import { Svg as f, GElement as t, Path as i, Line as a, Polygon as k } from "./Elements.js";
const y = ({
  className: o = "",
  fill: e = c.orange,
  viewBox: l = "0 0 40 33",
  $cssHelper: d = h,
  focusable: n
}) => /* @__PURE__ */ r(
  f,
  {
    className: m({ [o]: !!o }),
    viewBox: l,
    $cssHelper: d,
    focusable: !!n,
    "aria-hidden": !n,
    children: /* @__PURE__ */ r(t, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(t, { transform: "translate(-20.000000, -672.000000)", children: /* @__PURE__ */ r(t, { transform: "translate(20.000000, 672.000000)", children: /* @__PURE__ */ s(t, { children: [
      /* @__PURE__ */ s(t, { transform: "translate(0.000000, 0.779727)", children: [
        /* @__PURE__ */ r(
          i,
          {
            d: "M5,1.5 C3.06700338,1.5 1.5,3.06700338 1.5,5 L1.5,26.4814815 C1.5,28.4144781 3.06700338,29.9814815 5,29.9814815 L34.5294118,29.9814815 C36.4624084,29.9814815 38.0294118,28.4144781 38.0294118,26.4814815 L38.0294118,5 C38.0294118,3.06700338 36.4624084,1.5 34.5294118,1.5 L5,1.5 Z",
            stroke: e,
            strokeWidth: "3",
            fill: "#FFFFFF"
          }
        ),
        /* @__PURE__ */ r(
          i,
          {
            d: "M11.5294118,17.1905458 C13.4533824,17.1905458 17.2941176,18.1619152 17.2941176,20.0901559 L17.2941176,20.0901559 L17.2941176,21.539961 L5.76470588,21.539961 L5.76470588,20.0901559 C5.76470588,18.1619152 9.60544118,17.1905458 11.5294118,17.1905458 Z M11.5294118,9.94152047 C13.1212913,9.94152047 14.4117647,11.2397201 14.4117647,12.8411306 C14.4117647,14.4425411 13.1212913,15.7407407 11.5294118,15.7407407 C9.93753219,15.7407407 8.64705882,14.4425411 8.64705882,12.8411306 C8.64705882,11.2397201 9.93753219,9.94152047 11.5294118,9.94152047 Z",
            fill: e,
            fillRule: "nonzero"
          }
        ),
        /* @__PURE__ */ r(
          a,
          {
            x1: "22.2352941",
            y1: "15.3265107",
            x2: "32.1176471",
            y2: "15.3265107",
            stroke: e,
            strokeWidth: "3",
            "stroke-linecap": "square"
          }
        ),
        /* @__PURE__ */ r(
          a,
          {
            x1: "22.2352941",
            y1: "20.297271",
            x2: "32.1176471",
            y2: "20.297271",
            stroke: e,
            strokeWidth: "3",
            "stroke-linecap": "square"
          }
        )
      ] }),
      /* @__PURE__ */ r(
        k,
        {
          fill: e,
          points: "30.3136073 10.9801997 28.8098855 12.3781676 28.9588008 10.323853 26.9347752 10.0127759 28.6241912 8.84905544 27.6039944 7.0631807 29.5617464 7.66635958 30.3136073 5.75048733 31.0654681 7.66635958 33.0232202 7.0631807 32.0030233 8.84905544 33.6924393 10.0127759 31.6684137 10.323853 31.817329 12.3781676"
        }
      )
    ] }) }) }) })
  }
);
export {
  y as default
};
